import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconEditorUppercase$1 = /*@__PURE__*/ proxyCustomElement(class WppIconEditorUppercase extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-editor-uppercase", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M6.49486 3.25007C6.81023 3.25448 7.08915 3.45572 7.19277 3.75361L10.8449 14.2536C10.981 14.6448 10.7742 15.0723 10.383 15.2084C9.99173 15.3445 9.56427 15.1376 9.42819 14.7464L8.64684 12.5L4.06127 12.5L3.20142 14.7661C3.05447 15.1533 2.6214 15.3482 2.23413 15.2012C1.84686 15.0543 1.65204 14.6212 1.79899 14.2339L5.78318 3.73393C5.89507 3.43904 6.1795 3.24567 6.49486 3.25007ZM4.63044 11L8.1251 11L6.45374 6.19485L4.63044 11ZM12 3.5C11.5858 3.5 11.25 3.83579 11.25 4.25V14.5C11.25 14.9142 11.5858 15.25 12 15.25H14.75C16.683 15.25 18.25 13.683 18.25 11.75C18.25 10.4396 17.5299 9.29746 16.4638 8.69761C16.953 8.14603 17.25 7.4202 17.25 6.625C17.25 4.89911 15.8509 3.5 14.125 3.5H12ZM15.75 6.625C15.75 7.52246 15.0225 8.25 14.125 8.25H12.75V5H14.125C15.0225 5 15.75 5.72754 15.75 6.625ZM14.75 13.75H12.75V9.75H14.75C15.8546 9.75 16.75 10.6454 16.75 11.75C16.75 12.8546 15.8546 13.75 14.75 13.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-editor-uppercase-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-editor-uppercase", "wpp-icon-editor-uppercase-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-editor-uppercase-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-editor-uppercase-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconEditorUppercase$1);
      }
      break;
  } });
}

const WppIconEditorUppercase = WppIconEditorUppercase$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconEditorUppercase, defineCustomElement };
